import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) {
        setError('Invalid password');
        return;
      }
      const data = await res.json();
      sessionStorage.setItem('admin_token', data.token);
      navigate('/admin/dashboard');
    } catch {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="w-16 h-16 rounded-2xl bg-slate-800 flex items-center justify-center mx-auto mb-6">
            <Lock className="h-7 w-7 text-slate-400" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            Admin Access
          </h1>
          <p className="text-sm text-slate-500">Enter your password to continue</p>
        </div>

        <form onSubmit={handleSubmit} data-testid="admin-login-form">
          <input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-slate-900 border border-slate-700 text-white rounded-lg px-4 py-3.5 text-sm mb-4 focus:ring-2 focus:ring-teal-500 focus:border-transparent placeholder:text-slate-600"
            autoFocus
          />
          {error && <div data-testid="admin-login-error" className="text-sm text-red-400 mb-4">{error}</div>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-teal-600 text-white font-semibold text-sm py-3.5 rounded-lg hover:bg-teal-500 transition-colors disabled:opacity-50"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
